import { render } from "./BuildingEdit.vue?vue&type=template&id=26b8b69a&scoped=true"
import script from "./BuildingEdit.vue?vue&type=script&lang=js"
export * from "./BuildingEdit.vue?vue&type=script&lang=js"

import "./BuildingEdit.vue?vue&type=style&index=0&id=26b8b69a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b8b69a"]])

export default __exports__